/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Metadata_No_FieldsInputs */



/**
* | output |
* | --- |
* | "This view has no editable fields." |
*
* @param {Iconik_Metadata_No_FieldsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_metadata_no_fields = /** @type {((inputs?: Iconik_Metadata_No_FieldsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Metadata_No_FieldsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("This view has no editable fields.")
	if (locale === "de") return /** @type {LocalizedString} */ ("This view has no editable fields.")
	if (locale === "it") return /** @type {LocalizedString} */ ("This view has no editable fields.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("This view has no editable fields.")
	if (locale === "es") return /** @type {LocalizedString} */ ("This view has no editable fields.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("This view has no editable fields.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("This view has no editable fields.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("This view has no editable fields.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("This view has no editable fields.")
	return /** @type {LocalizedString} */ ("This view has no editable fields.")
});